<template>
  <div class="container">
    <v-row class="page-header">
      <v-col class="page-title" cols="12">
        <v-toolbar-title class="font-bold">{{ $t('lbl.converters.page_header') }}</v-toolbar-title>
      </v-col>
    </v-row>
    <v-row class="custom-form-control custom-form-control-type-2 custom-figma-1">
      <v-col cols="12" class="search-conditions-display">
        <div class="pl-0 pt-0 pb-0 collapse-search-conditions hide">
          <v-btn
            class="btn btn-top"
            color="primary"
            @click.native="displaySearchConditions('collapse')"
          >
            <v-icon x-small class="mr-2">fa fa-chevron-up</v-icon>
            {{ $t('btn.common.collapseConditions') }}
          </v-btn>
        </div>
        <div class="pl-0 pt-0 pb-0 expand-search-conditions">
          <v-btn
            class="btn btn-top"
            color="primary"
            @click.native="displaySearchConditions('expand')"
          >
            <v-icon x-small class="mr-2">fa fa-chevron-down</v-icon>
            {{ $t('btn.common.expandConditions') }}
          </v-btn>
        </div>
      </v-col>
      <v-col cols="12" class="pt-0 pb-0">
        <v-row>
          <v-col
            class="comm-header-col data-query-section pb-0 pt-0 mt-0 custom-figma-1"
            cols="12"
            lg="8"
            md="8"
          >
            <v-row>
              <v-col cols="12" lg="4" md="3" class="pt-0 pb-0">
                <v-text-field
                  v-model="s_item.cvtrNm"
                  @keyup.enter.native="searchItem"
                  :label="$t('lbl.common.conditionSearch.findbyName')"
                  class="custom-selectbox"
                  hide-details
                  dense
                  filled
                ></v-text-field>
              </v-col>
              <v-col cols="12" lg="2" md="3" class="pt-0 pb-0">
                <v-autocomplete
                  v-model="s_item.cvtrTpCd"
                  :items="types"
                  :menu-props="{ offsetY: true }"
                  :label="$t('lbl.common.conditionSearch.selectType')"
                  @change="searchItem"
                  class="custom-selectbox"
                  hide-details
                  dense
                  filled
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" lg="6" md="3" class="pt-0 pb-0">
                <v-text-field
                  v-model="s_item.cvtrPttn"
                  @keyup.enter.native="searchItem"
                  :label="$t('lbl.converters.info')"
                  class="custom-selectbox"
                  hide-details
                  dense
                  filled
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
          <v-col
            class="comm-header-col date-query-section pb-0 pt-0 pr-0 mt-0 text-right custom-figma-1"
            cols="12"
            lg="4"
            md="4"
          >
            <div class="pl-0 pt-0 pb-0 d-inline-flex btn-control"></div>
            <div class="pl-0 pt-0 pb-0 d-inline-flex btn-control">
              <v-btn class="btn btn-search btn-width-1" color="primary" @click.native="searchItem">
                <v-icon x-small class="mr-1">fa fa-search</v-icon>
                {{ $t('btn.common.search') }}
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row class="custom-pagination-figma-v3-first">
      <v-col class="page-control-content page-control-bg">
        <v-row>
          <v-col lg="6" md="6">
            <v-row>
              <v-col class="page-control-bg" cols="12">
                <v-btn :disabled="!$auth.manage" @click="openAddPartnerDialog" class="btn btn-add">
                  {{ $t('btn.common.add') }}
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
          <v-col lg="2" md="1"></v-col>
          <v-col lg="4" md="5" class="filter-search">
            <v-row>
              <v-col class="mr-0 pr-0 pl-0" lg="5" md="5">
                <v-select
                  v-model="searchBy"
                  :items="searchByItems"
                  :placeholder="$t('lbl.common.searchTypePlaceHolder')"
                  @change="onFilterConverter"
                  class="search-by data-table-select-box custom-selectbox pla-col mr-0 flat-file-selectbox"
                  height="40"
                  hide-details
                  dense
                  solo
                ></v-select>
              </v-col>
              <v-col class="ml-0 pl-0" cols="12" md="7">
                <v-text-field
                  v-model="search"
                  :placeholder="$t('lbl.common.searchPlaceHolder')"
                  @input="onFilterConverter"
                  @click:append="onFilterConverter"
                  @keyup.enter="onFilterConverter"
                  class="data-table-filter-text-field search-button-data-analysis-table flat-file"
                  heigth="40"
                  append-icon="fa fa-search"
                  hide-details
                  dense
                  solo
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <system-progress :sysloading="isLoading" :sysloadingTitle="sysloadingTitle"></system-progress>
      <v-col cols="12" class="pt-0 pb-0">
        <v-data-table
          :headers="headers"
          :items="listData"
          :hide-default-footer="true"
          :page.sync="page"
          :items-per-page="itemsPerPage"
          :fixed-header="true"
          :height="tableHeight"
          @page-count="pageCount = $event"
          group-by="cvtrId"
          :group-desc="sortDescending"
          :class="[
            'list-table code-table srm-list-table custom-border-table',
            totalCnt > 0 ? '' : 'custom-border-table-not-data',
          ]"
          no-data-text="No matching records found"
        >
          <template v-slot:item.INDEX="{ item }">
            <div class="index-col">{{ item.seq + 1 }}</div>
          </template>
          <template v-slot:group.header="{ group, items, isOpen, toggle, remove }">
            <td colspan="2" class="pl-0">
              <v-btn icon @click="toggle" class="ml-0">
                <v-icon v-if="isOpen" small>mdi-minus</v-icon>
                <v-icon v-else small>mdi-plus</v-icon>
              </v-btn>
              <span class="ml-1">{{ items[0].cvtrNm }}</span>
            </td>
            <td colspan="1" class="pl-0"></td>
            <td colspan="1" class="pl-0">
              <div class="text-center">
                <v-btn
                  small
                  text
                  icon
                  @click="editItem(items[0], 'Edit')"
                  :disabled="!$auth.manage"
                >
                  <icon-svg :disabled="!$auth.manage" iconName="edit" />
                </v-btn>
                <v-btn
                  small
                  text
                  icon
                  @click="editItem(items[0], 'Copy')"
                  :disabled="!$auth.manage"
                >
                  <icon-svg :disabled="!$auth.manage" iconName="copy" />
                </v-btn>
                <v-btn small text icon @click="deleteConverter(items[0])" :disabled="!$auth.manage">
                  <icon-svg :disabled="!$auth.manage" iconName="delete" />
                </v-btn>
              </div>
            </td>
            <td colspan="1" class="text-center">
              <span>{{ items[0].updDt }}</span>
            </td>
            <td colspan="1">
              <span>{{ items[0].updUsrId }}</span>
            </td>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-row v-show="totalCnt > 0" class="custom-pagination-figma-v3-last">
      <v-col class="page-control-content page-control-bg transaction-pagi">
        <v-row>
          <v-col lg="12" md="12">
            <v-row>
              <v-col class="page-control-bg text-left pa-0" cols="6">
                <div class="custom-pagi-selectbox">
                  <v-select
                    v-model="itemsPerPage"
                    hide-details
                    dense
                    solo
                    :items="rowPerPage"
                    class="data-table-select-box custom-selectbox mr-0 page-flat-file-selectbox"
                  >
                  </v-select>
                </div>
              </v-col>
              <v-col class="page-control-bg text-right pa-0" cols="6">
                <div class="page-showing">
                  <v-label>
                    {{ itemsPerPage * (page - 1) + 1 }} ~
                    {{ totalCnt - itemsPerPage * page > 0 ? itemsPerPage * page : totalCnt }}
                    of {{ totalCnt }}
                  </v-label>
                </div>
                <button
                  type="button"
                  @click="handlePageChange(1)"
                  :class="[
                    'custom-btn-first-last-paging',
                    page == 1 ? ' v-pagination__navigation--disabled' : '',
                  ]"
                >
                  <div class="ml-2 pr-2 d-inline">
                    <span><i class="fa fa-sm fa-step-backward"></i></span>
                  </div>
                </button>
                <button
                  type="button"
                  @click="changePageByTextbox(-1)"
                  :class="[
                    'mr-3 custom-btn-first-last-paging',
                    page - 1 < 1 ? ' v-pagination__navigation--disabled' : '',
                  ]"
                >
                  <div class="ml-2 pr-2 d-inline">
                    <span><i class="fa fa-lg fa-caret-left"></i></span>
                  </div>
                </button>
                <v-text-field
                  v-model="pageEnter"
                  hide-details
                  dense
                  solo
                  class="data-table-filter-text-field custom-pagi-selectbox page-selectbox"
                  @keyup.enter="changePageByTextbox(0)"
                ></v-text-field
                ><label>/ {{ pageCount }}</label>
                <button
                  type="button"
                  @click="changePageByTextbox(1)"
                  :class="[
                    'ml-3 custom-btn-first-last-paging',
                    page + 1 > pageCount ? ' v-pagination__navigation--disabled' : '',
                  ]"
                >
                  <div class="mr-2 pl-2 d-inline">
                    <span><i class="fa fa-lg fa-caret-right"></i></span>
                  </div>
                </button>
                <button
                  type="button"
                  @click="handlePageChange(pageCount)"
                  :class="[
                    'custom-btn-first-last-paging',
                    page == pageCount ? ' v-pagination__navigation--disabled' : '',
                  ]"
                >
                  <div class="mr-2 pl-2 d-inline">
                    <span><i class="fa fa-sm fa-step-forward"></i></span>
                  </div>
                </button>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <div v-for="dialog in dialogs" :key="dialog.id" class="dialogs">
      <AddPConverter
        v-if="dialog.type == 'AddPConverter'"
        :id="dialog.id"
        :cvtrTpCdList="cvtrTypes"
        ref="addMapLayout"
        :closeDialog="removeDialog"
        :dragEnd="dialogDragEnd"
        :dragStart="selectDialog"
        :move="dialogDragEnd"
        :options="dialog.options"
        @refeshList="searchItem"
      ></AddPConverter>
      <versionHistory
        v-if="dialog.type == 'versionHistory'"
        class="custom-dialog mapper-version"
        :closeDialog="removeDialog"
        :dragEnd="dialogDragEnd"
        :dragStart="selectDialog"
        :move="dialogDragEnd"
        :options="dialog.options"
        :id="dialog.id"
        title="Converter"
      ></versionHistory>
    </div>
    <dialogWindow
      ref="deleteDialog"
      :info="editedItem.name"
      size="max"
      title="Delete Converter"
      :detail="$t('msg.common.infoConfirm.detail', ['delete the Converter'])"
      color="confirmation"
      :showCancel="true"
      @select-ok="actionDel()"
    ></dialogWindow>
    <dialogWindow
      ref="deleteCvtr"
      title="Delete Converter"
      size="max"
      :detail="$t('lbl.processSetup.delComponent', ['converter'])"
      color="confirmation"
      :showCancel="true"
      @select-ok="actionDel()"
    ></dialogWindow>
  </div>
</template>

<script>
import dialogWindow from '@/vue-dlb/components/NewDialog.vue';
import { resizeTableHeight } from '@/vue-dlb/common/common';
import $ from 'jquery';
import { mapState } from 'vuex';
import SystemProgress from '@/vue-dlb/components/SystemProgress.vue';
import versionHistory from '@/vue-caas/components/DelHistoryWorkflowDialog.vue';
import AddPConverter from '@/vue-caas/views/converter/ConverterAdd.vue';
import IconSvg from '@/vue-caas/components/IconBase.vue';
import cfg from '@/vue-caas/config/config.js';
import EventBus from '@/vue-caas/views/process/component/event-bus.js';

export default {
  components: {
    dialogWindow,
    SystemProgress,
    versionHistory,
    AddPConverter,
    IconSvg, // 2021.12.1 SPKA-297 svg icon
  },
  data() {
    return {
      sortDescending: true,
      tableHeight: '',
      isCreated: false,
      page: 1,
      pageCount: 0,
      itemsPerPage: 50,
      search: '',
      listData: [],
      dialogs: [],
      arrLayoutDialog: [],
      dialogId: 1,
      dialog: false,
      totalCnt: 0,
      pageEnter: 1,
      headers: [
        { text: this.$t('tbl.common.columnNo'), value: 'INDEX', width: '60px' },
        { text: 'Type', value: 'cvtrTpCdNm', width: '170px' },
        { text: this.$t('lbl.converters.info'), value: 'cvtrPttn' },
        {
          text: 'Manage',
          value: 'manage',
          align: 'center',
          width: '120px',
          sortable: false,
        },
        {
          text: 'Last Update',
          value: '',
          align: 'center',
          width: '170px',
          sortable: false,
        },
        {
          text: 'Update User',
          value: '',
          align: 'left',
          width: '170px',
          sortable: false,
        },
      ],
      s_item: {
        cvtrNm: '',
        cvtrTpCd: '',
        cvtrPttn: '',
      },
      editedIndex: -1,
      editedItem: {
        action: '',
      },
      defaultItem: {},
      types: [],
      cvtrTypes: [],
      searchByItems: [
        { text: this.$t('lbl.common.searchTypePlaceHolder'), value: 'all' },
        { text: 'Name', value: 'cvtrNm' },
        { text: 'Type', value: 'cvtrTpCdNm' },
        { text: 'Information', value: 'cvtrPttn' },
      ],
      rowPerPage: [
        { value: 10, text: 'Show 10' },
        { value: 25, text: 'Show 25' },
        { value: 50, text: 'Show 50' },
        { value: 75, text: 'Show 75' },
        { value: 100, text: 'Show 100' },
      ],
      searchBy: 'all',
      prnrList: [{ value: '', text: this.$t('lbl.common.conditionSearch.all') }],
      isClick: true,
      isLoading: false,
      selectedRow: '',
    };
  },
  async created() {
    await this.$store.dispatch('caascommon/getComCdList', { grpCd: 'P06' }).then(() => {
      this.cvtrTypes = this.$store.getters['caascommon/comCdList'];
      this.types = [{ text: this.$t('lbl.common.conditionSearch.all'), value: '' }];
      for (let i = 0; i < this.cvtrTypes.length; i++) {
        this.types.push(this.cvtrTypes[i]);
      }
    });
    this.searchItem();
    EventBus.$on('delete-item', this.actionDel);
    this.isCreated = true;
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? 'New Item' : 'Edit Item';
    },
    ...mapState('common', {
      sysloadingTitle: 'sysloadingTitle',
    }),
  },
  methods: {
    displaySearchConditions(action) {
      if (action === 'expand') {
        $('.date-query-section').css('display', 'block');
        $('.data-query-section').css('display', 'block');
        $('.expand-search-conditions').css('display', 'none');
        $('.collapse-search-conditions').css('display', 'block');
      } else {
        $('.date-query-section').css('display', 'none');
        $('.data-query-section').css('display', 'none');
        $('.expand-search-conditions').css('display', 'block');
        $('.collapse-search-conditions').css('display', 'none');
      }
    },
    actionDel() {
      this.$store.dispatch('deleteConverter', { cvtrId: this.editedItem.cvtrId }).then(() => {
        console.log('--------- Delete converter -----');
        this.searchItem();
      });
    },
    deleteConverter(item) {
      this.editedItem = Object.assign({}, item);
      let self = this;
      if (cfg.isDlb) {
        self.$refs.deleteDialog.dialog = true;
      } else {
        this.$store
          .dispatch('getListUseInWorkflow', { type: 'CVT', value: item.cvtrId })
          .then((res) => {
            if (res.length > 0) {
              self.openVersionHistory(res, item);
            } else {
              self.$refs.deleteDialog.dialog = true;
            }
          });
      }
    },
    openAddPartnerDialog() {
      let type = 'AddPConverter';
      let item = {
        ROWID: 0,
        action: 'Add',
      };
      let indexArrDialog = this.findDialog('AddPConverter_0');
      if (indexArrDialog != null) {
        return;
      }
      this.newDialog(item, type) - 1;
    },
    editItem(rowItem, action) {
      let type = 'AddPConverter';
      let item = {
        ROWID: 0,
        action: action,
        data: rowItem,
      };
      let indexArrDialog = this.findDialog('AddPConverter_0');
      if (indexArrDialog != null) {
        return;
      }
      this.newDialog(item, type) - 1;
    },
    onClickRow(item) {
      this.selectedRow = item.id;
    },
    openVersionHistory(list, val) {
      let type = 'versionHistory';
      let item = {};
      item.ROWID = 0;
      item.versionList = list;
      item.comNm = val.name;
      item.item = val;
      let indexArrDialog = this.findDialog('versionHistory_0');
      if (indexArrDialog != null) {
        this.dialogs[indexArrDialog].options.item = item;
        return;
      }
      this.newDialog(item, type) - 1;
    },
    searchItem() {
      this.isLoading = true;
      this.$store
        .dispatch('getConverterSearchList', this.s_item)
        .then(() => {
          this.listData = this.$store.getters.converterList;
          this.listData.map((e) => {
            let index = this.types.findIndex((r) => r.value === e.cvtrTpCd);
            e.cvtrTpCdNm = index > -1 ? this.types[index].text : '';
          });
          this.isLoading = false;
          this.totalCnt = this.listData.length;
          this.caculatePageCount();
        })
        .catch((ex) => {
          this.isLoading = false;
        });
    },
    onFilterConverter(str) {
      setTimeout(() => {
        this.$store
          .dispatch('setFilterConverter', {
            searchBy: this.searchBy,
            str: this.search,
          })
          .then(() => {
            this.listData = this.$store.getters.converterList;
            this.totalCnt = this.listData.length;
            this.caculatePageCount();
          });
      }, 300);
    },
    findDialog(id, dialogs) {
      if (!dialogs) dialogs = this.dialogs;
      let index = dialogs.findIndex((val) => {
        return val.id === id;
      });
      return index > -1 ? index : null;
    },
    newDialog(item, type) {
      return this.dialogs.push(this.generateDialog(item, type));
    },
    generateDialog(item, type) {
      let id = `${type}_${item.ROWID}`;
      this.arrLayoutDialog.push({ id: id });
      this.dialogId++;
      let name = 'Dialog ' + id;
      let options = {
        left: 30 * this.dialogId,
        top: 30 * this.dialogId,
        item: item,
      };
      return { id, name, type, options };
    },
    dialogDragEnd(obj) {
      let index = this.findDialog(obj.id);
      this.$set(this.dialogs[index].options, 'left', obj.left);
      this.$set(this.dialogs[index].options, 'top', obj.top);
    },
    selectDialog(obj) {
      let index = this.findDialog(obj.id);
      this.selected = this.dialogs[index];
    },
    removeDialog(dialog) {
      let id = dialog.id;
      let index = this.findDialog(id);
      let indexArrDialog = this.findDialog(id, this.arrLayoutDialog);
      this.arrLayoutDialog.splice(indexArrDialog, 1);
      this.dialogs.splice(index, 1);
      if (this.selected && this.selected.id === id) this.selected = null;
    },
    changePageByTextbox(value) {
      let data = parseInt(this.pageEnter);
      if (isNaN(data)) {
        this.pageEnter = this.page;
        return;
      } else {
        this.page = data > this.pageCount ? this.pageCount : data < 1 ? 1 : data;
        this.pageEnter = this.page;
      }
      this.page += value;
    },
    handlePageChange(value) {
      this.page = value;
    },
    caculatePageCount() {
      if (this.totalCnt % this.itemsPerPage === 0) {
        this.pageCount = this.totalCnt / this.itemsPerPage;
      } else {
        this.pageCount = Math.floor(this.totalCnt / this.itemsPerPage) + 1;
      }
    },
  },
  watch: {
    listData() {
      return this.listData;
    },
    page() {
      this.pageEnter = this.page;
    },
  },
  updated: function() {
    let self = this;
    let arrClassMinus = ['.page-control-content'];
    let arrClassPlus = [];

    if (this.isCreated) {
      let h1 = resizeTableHeight(arrClassMinus, arrClassPlus, true);
      self.tableHeight = h1 + 'px';
      this.isCreated = false;
    }

    $(window).resize(function(event) {
      let h1 = resizeTableHeight(arrClassMinus, arrClassPlus, true);
      self.tableHeight = h1 + 'px';
    });
  },
  mounted() {
    window.addEventListener('storage', (event) => {
      if (event.key === 'processSharedData') {
        const updatedState = JSON.parse(event.newValue);
        if (updatedState?.CVT) {
          this.searchItem();
        }
      }
    });
  },
};
</script>
